import { apiService } from "../../../../services/api/apiService";
import { Pagination, PaginationFilterDto } from "../../../../types/Pagination";
import { createDictionaryApiFactory } from "../../Dictionaries/api/dictionaryApiFactory";
import { UserCommunicationTypeFormDto, UserCommunicationTypeListItemDto } from "../types";

export function mapDictionaryState(data: any): UserCommunicationTypeListItemDto {    
    const deletedAt = (data as any).deletedDate ?? (data as any).dataBaixa ?? null;

    return {
        ...data,
        isActive: !deletedAt
    };
}

const BASE_URL = "userCommunicationTypes";
const userCommunicationType = createDictionaryApiFactory(BASE_URL);

export const getUserCommunicationTypes = async (body: PaginationFilterDto): Promise<Pagination<UserCommunicationTypeListItemDto>> => {
    const response = await apiService.post<PaginationFilterDto, Pagination<UserCommunicationTypeListItemDto>>(`/${BASE_URL}/search`, body);
    return { ...response, items: response.items.map(mapDictionaryState) };
}

export const getUserCommunicationTypeById = async (id: number): Promise<UserCommunicationTypeFormDto> => 
    await apiService.get<UserCommunicationTypeFormDto>(`/${BASE_URL}/detail/${id}`);

export const createUserCommunicationType = async (body: UserCommunicationTypeFormDto): Promise<void> => 
    await apiService.post<UserCommunicationTypeFormDto, void>(`/${BASE_URL}/create`, body);

export const updateUserCommunicationType = async (id: number, body: UserCommunicationTypeFormDto): Promise<void> => 
    await apiService.put<UserCommunicationTypeFormDto, void>(`/${BASE_URL}/${id}`, body);

export const exportCsvUserCommunicationType = userCommunicationType.exportCsv;
export const getRequestTypesByClient = userCommunicationType.getSelectOptions;
